import React from 'react';
import { useReadOnly } from '../context/ReadOnlyContext';
import { Shield, X, Clock } from 'lucide-react';
import { Button } from './ui/button';

const ReadOnlyBanner = () => {
  const { isReadOnly, targetUser, timeRemaining, endReadOnlySession } = useReadOnly();

  if (!isReadOnly) return null;

  const formatTimeRemaining = (seconds) => {
    if (!seconds) return '--:--';
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-600 text-white shadow-lg">
      <div className="max-w-full mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <Shield className="h-5 w-5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm">
              Read-Only Support View
            </p>
            <p className="text-xs text-amber-100 truncate">
              Viewing as: {targetUser?.name} ({targetUser?.email})
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4 flex-shrink-0">
          {/* Time Remaining */}
          <div className="hidden sm:flex items-center gap-2 bg-amber-700 px-3 py-1 rounded-full">
            <Clock className="h-4 w-4" />
            <span className="text-xs font-mono font-semibold">
              {formatTimeRemaining(timeRemaining)}
            </span>
          </div>

          {/* Exit Button */}
          <Button
            onClick={endReadOnlySession}
            className="bg-white text-amber-900 hover:bg-amber-50 px-4 py-2 h-auto text-sm font-semibold flex items-center gap-2"
          >
            <X className="h-4 w-4" />
            Exit Support View
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyBanner;
